import * as Accordion from '@radix-ui/react-accordion'
import React, { PropsWithChildren } from 'react'

import Chevron from '@/components/Icon/Chevron'

import { accordionChevron, accordionContent, accordionHeader, accordionHeaderTrigger } from './styles.css'

export const AccordionRoot = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<{ defaultOpenedItem?: string; onToggle: (value: string) => void }>
>(({ children, defaultOpenedItem, onToggle, ...props }, forwardedRef) => (
  <Accordion.Root
    collapsible
    defaultValue={defaultOpenedItem}
    type="single"
    onValueChange={onToggle}
    {...props}
    ref={forwardedRef}
  >
    {children}
  </Accordion.Root>
))

export const AccordionTrigger = React.forwardRef<HTMLButtonElement, PropsWithChildren<{}>>(
  ({ children, ...props }, forwardedRef) => (
    <Accordion.Header className={accordionHeader}>
      <Accordion.Trigger className={accordionHeaderTrigger} {...props} ref={forwardedRef}>
        {children}
        <Chevron aria-hidden className={accordionChevron} width={15} />
      </Accordion.Trigger>
    </Accordion.Header>
  )
)

export const AccordionItem = React.forwardRef<HTMLDivElement, PropsWithChildren<{ name: string }>>(
  ({ children, name, ...props }, forwardedRef) => (
    <Accordion.Item value={name} {...props} ref={forwardedRef}>
      {children}
    </Accordion.Item>
  )
)

export const AccordionContent = React.forwardRef<HTMLDivElement, PropsWithChildren<{}>>(
  ({ children, ...props }, forwardedRef) => (
    <Accordion.Content className={accordionContent} {...props} ref={forwardedRef}>
      <div className="AccordionContentText">{children}</div>
    </Accordion.Content>
  )
)
